<div class="cosmos-checkbox-filter">
    <div class="cosmos-checkbox-filter__field">
        <div class="cosmos-checkbox-filter__content">
            <div class="cosmos-checkbox-filter__checkbox__container">
              <mat-checkbox
                (change)="onFilterChange($event)"
                class="cosmos-checkbox-filter__checkbox"
              ></mat-checkbox>
            </div>
            <div class="cosmos-checkbox-filter__name">
              <span>{{ _filterDescription }}</span>
            </div>
        </div>
    </div>
</div>
